import "dotenv/config";

import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:5001/api"
  // baseURL: `${process.env.REACT_APP_URL}/api`
  baseURL: `${process.env.REACT_APP_API_PATH}api`

});

// Add a request interceptor to attach the token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance; 
